import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  btnMenu: {
    padding: 0,
    margin: theme.spacing(0, 1),
  },
  container: {
    '& .profile': {
      '&-infos': {
        padding: theme.spacing(3),
        width: 260,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        '&-avatar': {
          marginBottom: theme.spacing(1),
        },
        '&-name': {
          color: theme.palette.primary.main,
          marginBottom: theme.spacing(1 / 2),
          textAlign: 'center',
        },
        '&-email': {
          color: theme.palette.text.secondary,
          marginBottom: theme.spacing(1),
          textAlign: 'center',
        },
      },
      '&-menu-item': {
        height: 48,

        '&-icon': {
          display: 'flex',
          color: theme.palette.text.hint,
          marginRight: theme.spacing(2),
        },
      },
    },
  },
  menuItemContainer: {
    minWidth: 36,
  },
}));

export default styles;
